<!--
 * @Author: amywulan
 * @Date: 2020-09-15 18:37:24
 * @LastEditors: amywulan
 * @LastEditTime: 2020-09-16 14:37:20
 * @Description: 我的优惠券
-->
<template>
  <div>
    <!-- 我的优惠券列表 -->
    <coupons-list :couponRid="couponRid" :bannerData="bannerData" :couponBusinessType="0" ref="couponsList"/>
    <!-- 商家券列表 -->
    <coupons-list :couponRid="couponRid" :bannerData="bannerData" :couponBusinessType="1" ref="couponsShopList"/>
  </div>
</template>
<script>
import couponsList from './couponsList'
import { voucherEntranceSw } from '../../track'

export default {
  name: 'myCoupons',
  props: {
    bannerData: {
      type: Object,
      default: {
        type: {}
      }
    }
  },
  components: {
    couponsList
  },
  data () {
    return {
      couponRid: ''
    }
  },
  async mounted () {
    voucherEntranceSw()
  },
  methods: {
    // 获取成功信息
    async getResultInfo () {
      this.$refs.couponsList.getCouponList()
      this.$refs.couponsShopList.getCouponList()
    },
    couponsShow (val) {
      this.$emit('couponsShow', val)
    }
  }

}
</script>
